import { render } from "./MaterialsAccordion.vue?vue&type=template&id=35ef2d34"
import script from "./MaterialsAccordion.vue?vue&type=script&lang=js"
export * from "./MaterialsAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__